// src/components/Arguente/ArguenteForm.jsx
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { criarArguente } from '../../services/arguenteService';

/**
 * Formulário para criação de um arguente.
 * @param {Object} props
 * @param {Function} props.onSuccess Callback executado após cadastro bem-sucedido.
 */
const ArguenteForm = ({ onSuccess }) => {
  const [usuarioId, setUsuarioId] = useState('');
  const [areasInteresse, setAreasInteresse] = useState('');
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setLoading(true);
    try {
      const payload = {
        usuarioId: Number(usuarioId),
        areasInteresse: areasInteresse
          .split(',')
          .map(area => area.trim())
          .filter(Boolean)
      };

      await criarArguente(payload);
      onSuccess();
      // opcional: limpar campos
      setUsuarioId('');
      setAreasInteresse('');
    } catch (err) {
      console.error('Erro ao cadastrar arguente:', err);
      setError('Falha ao cadastrar arguente. Tente novamente.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <div>
        <label>
          ID do Usuário:
          <input
            type="number"
            placeholder="ID do Usuário"
            value={usuarioId}
            onChange={(e) => setUsuarioId(e.target.value)}
            required
            disabled={loading}
          />
        </label>
      </div>
      <div>
        <label>
          Áreas de Interesse:
          <input
            type="text"
            placeholder="Áreas de Interesse (separadas por vírgula)"
            value={areasInteresse}
            onChange={(e) => setAreasInteresse(e.target.value)}
            required
            disabled={loading}
          />
        </label>
      </div>
      {error && <p style={{ color: 'red' }}>{error}</p>}
      <button type="submit" disabled={loading}>
        {loading ? 'Cadastrando...' : 'Registrar Arguente'}
      </button>
    </form>
  );
};

ArguenteForm.propTypes = {
  onSuccess: PropTypes.func.isRequired
};

export default ArguenteForm;
